import { NavigateFunction } from "react-router-dom";


export function updateSearchParams(
  search: string,
  navigate: NavigateFunction,
  newParams: Record<string, string | undefined | null>,
  pathname?: string  // optional for if you want to supply path
) {
  const params = new URLSearchParams(search);

  Object.entries(newParams).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      params.delete(key); // remove param if value is null/undefined
    } else {
      params.set(key, value);
    }
  });

  navigate(
    {
      ...(pathname ? { pathname } : {}),
      search: params.toString(),
    },
    { replace: true }
  );
}